import { render, staticRenderFns } from "./RegisterLitter.vue?vue&type=template&id=6dea6386"
import script from "./RegisterLitter.vue?vue&type=script&lang=ts"
export * from "./RegisterLitter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports